import { Button } from 'antd';
import { getReaderHref } from '../../util/getReaderHref';
import useWebReaderProducts from '../Titles/hooks/useWebReaderProducts';
import ApprovedIcon from '../UI/ApprovedIcon';

export const RoundButton = ({
	sku,
	isLoading,
	hasWebReaderGalleyAccess,
}: {
	sku: string;
	isLoading: boolean;
	hasWebReaderGalleyAccess: boolean;
}) => {
	const webReaderProducts = useWebReaderProducts();
	const isActiveWebReaderProduct = webReaderProducts.isActive(sku);
	return (
		<div className="relative">
			<Button
				shape="circle"
				target="_blank"
				color="success"
				loading={isLoading}
				disabled={!hasWebReaderGalleyAccess}
				href={getReaderHref(sku)}>
				{isActiveWebReaderProduct && <ApprovedIcon />}
				<div
					className="icon-book"
					style={{
						fontSize: 18,
						marginTop: '2px',
						opacity: isActiveWebReaderProduct ? 0.5 : 1,
					}}
				/>
			</Button>
		</div>
	);
};
